import { render } from "./SideNavDrawer.vue?vue&type=template&id=e4f9607c"
import script from "./SideNavDrawer.vue?vue&type=script&lang=js"
export * from "./SideNavDrawer.vue?vue&type=script&lang=js"

import "./SideNavDrawer.vue?vue&type=style&index=0&id=e4f9607c&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__